export const initialState = {
  showProcessing: { show: false, title: "" },
};

export const actionTypes = {
  SET_SHOW_PROCESSING: "SET_SHOW_PROCESSING",
};

const reducer = (state, action) => {
  //console.log(action);

  switch (action.type) {
    case actionTypes.SET_SHOW_PROCESSING:
      return {
        ...state,
        showProcessing: action.showProcessing,
      };
    default:
      return state;
  }
};

export default reducer;
